import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AuthUser } from 'app/core/auth/core/auth-user.model';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@Component({
    selector: 'odq-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class AppHeaderComponent {
  @Input() isAuthorized: boolean;
  @Input() user: AuthUser;
  @Input() userLoading: boolean;
  @Input() sidebarInfoVisible: boolean;
  @Input() tokenExpiringIn: number;
  @Output() loggedIn = new EventEmitter<any>();
  @Output() loggedOut = new EventEmitter<any>();
  @Output() passwordReset = new EventEmitter<any>();
  @Output() languageChanged = new EventEmitter<string>();
  @Output() sidebarInfoToggled = new EventEmitter<any>();

  public config: PerfectScrollbarConfigInterface = {};
  // This is for Notifications
  notifications: object[] = [];
  sidebarInfo: object[] = [];

  // This is for Mymessages
  mymessages: object[] = [];
  
  constructor() {
  }

  login() {
    this.loggedIn.emit();
  }

  logout() {
    this.loggedOut.emit();
  }

  resetPassword() {
    this.passwordReset.emit();
  }

  renewSession() {
    this.loggedIn.emit();
  }

  //INFO: Please do not forget to remove the code if we ever decide to remove the code from the INFO session
  useLanguage(lang: string) {
    this.languageChanged.emit(lang);
  }

  toggleSidebarInfo() {
    this.sidebarInfoVisible = !this.sidebarInfoVisible;
    this.sidebarInfoToggled.emit();
  }
}
